import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { Box, Card, Container, Typography } from "@mui/material";
import { PageTitle } from "../../commanComponents/PageTitle";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { String } from "../../constants/Strings";
import { getColor } from "../../style/color/color";

import { ReactComponent as Bank } from "../../assets/icon/bank.svg";
import { ReactComponent as Deposit } from "../../assets/icon/deposit.svg";
import { ReactComponent as MutualFund } from "../../assets/icon/mutualfund.svg";
import { ReactComponent as Stocks } from "../../assets/icon/stocks.svg";
import { ReactComponent as Policy } from "../../assets/icon/policy.svg";
import { ReactComponent as EMI } from "../../assets/icon/loan.svg";
import { ReactComponent as NPS } from "../../assets/icon/policy.svg";
import { ReactComponent as EVGExpense } from "../../assets/icon/expenses.svg";
import { ReactComponent as Loan } from "../../assets/icon/loan.svg";
import { ReactComponent as PF } from "../../assets/icon/deposit.svg";

import FinancialBox from "./FinancialBox";
import ACRButton from "../../commanComponents/ACRButton";
import PolicyModel from "./Boxes/PolicyModel";
import DepositModel from "./Boxes/DepositModel";
import NPSModel from "./Boxes/NPSModel";

import { useLocation, useNavigate } from "react-router-dom";
import { useFinancialSnapshot } from "../../api/apiEndpoints/FinancialSnapshot";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import { AuthContext } from "../../Hooks/context/AuthContext";

import ProfiduntFundModel from "./Boxes/ProfiduntFundModel";
import { DataContext } from "../../Hooks/context/ChildData";
import { AccountAagregatorContext } from "../../Hooks/context/AccountAaggregator";
import { formatToIndianCurrency } from "../../logic/CurrencyFormatter";
import {
  StyledACRButton,
  StyledContainer,
  StyledDivider,
} from "../../style/styleComponents/StyledFinancialSnapshot";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";
const FinancialSnapshot = () => {
  const [isClick, setIsClick] = useState(false);
  const [financialValues, setFinancialValues] = useState({
    totalDepositAmount: 0,
    totalNpsAmount: 0,
    providentFundAmount: 0,
    totalPolicyAmount: 0,
    totalBankBalanceAmount: 0,
    totalMutualFundsAmount: 0,
    totalStocksAmount: 0,
    avgExpenses: 0,
    loanAmount: 0,
    emiAmount: 0,
    totalAssetAmount: 0,
    monthlyIncomeAmount: 0,
  });
  const [selectedBox, setSelectedBox] = useState("");
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  const [errorFields, setErrorFields] = useState(false);

  const navigation = useNavigate();
  const location = useLocation();
  const locationcheck = location.state.replace;

  const hasFetched = useRef(false);
  const { enterManually } = useContext(DataContext);
  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { userId } = authTokens;
  const { collectedAccountAggregatorData, collectAccountAggregatorData } =
    useContext(AccountAagregatorContext);
  const { saveFinancialSnapshot, getFinancialSnapshot } =
    useFinancialSnapshot();

  useEffect(() => {
    const fetchFinancialSnapshot = async () => {
      if (!userId) return;
      try {
        const response = await getFinancialSnapshot({ userId });

        if (response.httpCode === 200) {
          if (response.response && typeof response.response === "object") {
            setFinancialValues(response.response || {});
          } else {
            setFinancialValues({});
          }
        } else {
          setSnackbarMessage({
            message:
              String.Dashboard.FinancialSnapshotMessages.fetchDataFromServer,
            severity: String.ErrorSeverity,
          });
          setSnackbarOpen(true);
        }
      } catch (error) {
        setSnackbarMessage({
          message:
            String.Dashboard.FinancialSnapshotMessages.fetchDataFromServer,
          severity: String.ErrorSeverity,
        });
        setSnackbarOpen(true);
      }
    };

    if (!enterManually && !hasFetched.current) {
      fetchFinancialSnapshot();
      hasFetched.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchAccountAagregator = async () => {
      if (collectedAccountAggregatorData.httpCode === 200) {
        setSnackbarOpen(true);
        setSnackbarMessage({
          message:
            String.Dashboard.FinancialSnapshotMessages
              .accountDetailsFetchSuccessfully,
          severity: String.successSeverity,
        });
        setFinancialValues(collectedAccountAggregatorData.response || {});
      } else {
      }
    };
    if (locationcheck) {
      fetchAccountAagregator();
    }
  }, [
    collectAccountAggregatorData.httpCode,
    collectAccountAggregatorData.response,
    collectedAccountAggregatorData,
    locationcheck,
  ]);

  const totalAssetAmount = useMemo(() => {
    const relevantKeys = [
      String.Dashboard.financialsnapshotFeilds.totalDepositAmount,
      String.Dashboard.financialsnapshotFeilds.totalNpsAmount,
      String.Dashboard.financialsnapshotFeilds.providentFundAmount,
      String.Dashboard.financialsnapshotFeilds.totalPolicyAmount,
      String.Dashboard.financialsnapshotFeilds.totalBankBalanceAmount,
      String.Dashboard.financialsnapshotFeilds.totalMutualFundsAmount,
      String.Dashboard.financialsnapshotFeilds.totalStocksAmount,
    ];

    return relevantKeys.reduce((acc, key) => {
      const value = Number(financialValues[key]) || 0;
      return acc + value;
    }, 0);
  }, [financialValues]);

  const HandleEdit = (boxType) => {
    setSelectedBox(boxType);
  };

  const handleClose = useCallback(() => {
    setSelectedBox("");
    setErrors({});
  }, []);
  const onHandleChange = useCallback((key, value) => {
    setFinancialValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const handleViewDashbord = async () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioFinancialSnapshotViewDashboard, verifyData.customerId);
    const requiredFields = [
      String.Dashboard.financialsnapshotFeilds.totalBankBalanceAmount,
      // "totalDepositAmount",
      String.Dashboard.financialsnapshotFeilds.totalPolicyAmount,
      String.Dashboard.financialsnapshotFeilds.avgExpenses,
    ];

    const errors = {};

    requiredFields.forEach((field) => {
      if (financialValues[field] === "" || !financialValues[field]) {
        errors[field] = true;
      }
    });

    if (Object.keys(errors).length > 0) {
      setErrorFields(true);
      const errorMessages = Object.keys(errors).map((field) => {
        switch (field) {
          case String.Dashboard.financialsnapshotFeilds.totalBankBalanceAmount:
            return String.Dashboard.mainDashboard.BankAmount;
          case String.Dashboard.financialsnapshotFeilds.totalPolicyAmount:
            return String.Dashboard.mainDashboard.PolicyAmount;
          case String.Dashboard.financialsnapshotFeilds.avgExpenses:
            return String.Dashboard.mainDashboard.AvgExpenseAmount;
          default:
            return "";
        }
      });
      setSnackbarMessage({
        message: errorMessages.join(", "),
        severity: String.ErrorSeverity,
      });
      setSnackbarOpen(true);
      return;
    } else {
      setErrorFields(false);
    }

    if (
      collectedAccountAggregatorData?.response?.policies &&
      collectedAccountAggregatorData.response.policies.length > 0
    ) {
      // First check for missing fields
      const missingFields =
        collectedAccountAggregatorData.response.policies.filter((policy) => {
          return !policy.policyType || policy.policyType === "";
        });

      if (missingFields.length > 0) {
        // Check if user has filled these values in the form
        const updatedPolicies = financialValues.policies || [];
        const stillMissingFields = updatedPolicies.filter((policy) => {
          return !policy.policyType || policy.policyType === "";
        });

        // Only show error if values are still missing after user input
        if (stillMissingFields.length > 0) {
          setSnackbarOpen(true);
          setSnackbarMessage({
            message:
              String.Dashboard.FinancialSnapshotMessages.EnterMissingPolicy,
            severity: String.ErrorSeverity,
          });
          return;
        }
      }
    }
    const { npsList, ...financialValuesWithoutNpsList } = financialValues;
    const data = {
      userId,
      ...financialValuesWithoutNpsList,
      totalMutualFundsAmount: financialValues.totalMutualFundsAmount || 0.0,
      totalStocksAmount: financialValues.totalStocksAmount || 0.0,
      totalNpsAmount: financialValues.totalNpsAmount || 0.0,
      loanAmount: financialValues.loanAmount || 0.0,
      emiAmount: financialValues.emiAmount || 0.0,
      providentFundAmount: financialValues.providentFundAmount,
      totalAssetAmount: totalAssetAmount,
      totalBankBalanceAmount:
        Number(financialValues.totalBankBalanceAmount) || 0, // Set to 0 if not a number
      totalDepositAmount: Number(financialValues.totalDepositAmount) || 0, // Set to 0 if not a number
      totalPolicyAmount: Number(financialValues.totalPolicyAmount) || 0, // Set to 0 if not a number
      avgExpenses: Number(financialValues.avgExpenses) || 0, // Set to 0 if not a number
    };

    try {
      const response = await saveFinancialSnapshot(data);

      if (response.httpCode === 200) {
        setSnackbarMessage({
          message:
            String.Dashboard.FinancialSnapshotMessages
              .financialSnapshotSaveSuccess,
          severity: String.successSeverity,
        });
        setSnackbarOpen(true);

        navigation(String.navigations.customerdashboard);
      } else {
        setSnackbarMessage({
          message:
            String.Dashboard.FinancialSnapshotMessages
              .financialSnapshotSaveError,
          severity: String.ErrorSeverity,
        });
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage({
        message:
          String.Dashboard.FinancialSnapshotMessages.ErrorWhileSavingData,
        severity: String.ErrorSeverity,
      });
      setSnackbarOpen(true);
    }
  };

  const handleDepositSubmit = (data) => {
    setFinancialValues((prev) => ({ ...prev, deposits: data }));
    const totalAmount = data.reduce((acc, deposit) => {
      const amount = Number(deposit.totalAmount);
      if (!isNaN(amount)) {
        return acc + amount;
      }
      return acc;
    }, 0);

    setFinancialValues((prev) => ({
      ...prev,
      totalDepositAmount: Number(totalAmount),
    }));
  };
  const handlePolicySubmit = (data) => {
    setFinancialValues((prev) => ({ ...prev, policies: data }));

    const totalPolicyCoverage = data.reduce((acc, policy) => {
      const amount = Number(policy.coverageAmount);
      if (!isNaN(amount)) {
        return acc + amount;
      }
      return acc;
    }, 0);

    setFinancialValues((prev) => ({
      ...prev,
      totalPolicyAmount: Number(totalPolicyCoverage),
    }));
  };
  const handleNPSSubmit = (data) => {
    const totalHolding = data.reduce((acc, nps) => {
      const amount = Number(nps.totalHolding);
      if (!isNaN(amount)) {
        return acc + amount;
      }
      return acc;
    }, 0);
    setFinancialValues((prev) => ({ ...prev, npsList: [] }));
    setFinancialValues((prev) => ({
      ...prev,
      totalNpsAmount: Number(totalHolding),
    }));
  };
  const handlePFSubmit = (data) => {
    setFinancialValues((prev) => ({ ...prev, pFList: data }));

    const dataArray = Object.values(data);

    const totalPF = dataArray.reduce((acc, pf) => {
      const amount = Number(pf.totalAmount);
      if (!isNaN(amount)) {
        return acc + amount;
      }
      return acc;
    }, 0);

    setFinancialValues((prev) => ({
      ...prev,
      providentFundAmount: totalPF,
    }));
  };

  return (
    <StyledContainer
      sx={{
        height: "100vh",
      }}
    >
      <Container sx={{ flexGrow: 1 }}>
        <PageTitle PageTitle={String.Dashboard.Title} />
        <LinearProgressBar
          dragMessage={String.Dashboard.snapshotDragMessage}
          progress={90}
          progressNumber={90}
          stepNumber={4}
        />
      </Container>
      <Card
        sx={{
          p: { xs: 3, sm: 3, md: 4 },
          ml: { xs: 2, sm: 2, md: "20px" },
          mr: { xs: 2, sm: 2, md: "20px" },
          mt: "30px",
          display: "flex",
          flexDirection: { xs: "row", sm: "row" },
          justifyContent: "space-between",
          backgroundColor: getColor.SecondaryMidnightBlue,
          color: getColor.PrimaryWhite,
          borderRadius: 5,
        }}
      >
        <Box sx={{ mb: { xs: 1, sm: 0 }, ml: "10px" }}>
          {" "}
          {/* Margin bottom for small screens */}
          <Typography
            sx={{
              fontSize: { xs: "1.25rem", sm: "1.5rem" },
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            {`${
              financialValues.totalAssetAmount
                ? formatToIndianCurrency(financialValues.totalAssetAmount)
                : formatToIndianCurrency(totalAssetAmount)
            }`}
          </Typography>
          <Typography
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 10,
              fontFamily: fonts.manrope,
              fontWeight: "500",
            }}
          >
            {String.Dashboard.TotalAsset}
          </Typography>
        </Box>
        <Box sx={{ mr: "10px" }}>
          <Typography
            sx={{
              fontSize: { xs: "1.25rem", sm: "1.5rem" },
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            {`${
              formatToIndianCurrency(financialValues.monthlyIncomeAmount) || 0
              // ? financialValues.monthlyIncomeAmount
              // : monthlyIncomeAmount
            }`}
          </Typography>
          <Typography
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 10,
              fontFamily: fonts.manrope,
              fontWeight: "500",
              textAlign: "right",
            }}
          >
            {String.Dashboard.MonthlyIncome}
          </Typography>
        </Box>
      </Card>
      <Box
        sx={{
          borderRadius: 5,
          border: "1px #A8ABB1 solid",
          mt: "20px",
          mr: "20px",
          ml: "20px",
          p: 2,
        }}
      >
        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.bankTitle}
          Icon={Bank}
          editVisible={false}
          value={financialValues.totalBankBalanceAmount}
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.totalBankBalanceAmount,
              value
            )
          }
          placeholderVal={"0"}
          belowText={String.Dashboard.financialsnapshotFeilds.availableBalance}
          asterrisk={true}
          errorChecks={errorFields}
          requireFeilds={true}
        />
        <StyledDivider />
        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.depositTitle}
          Icon={Deposit}
          editVisible={true}
          onEditClick={HandleEdit}
          setIsClick={setIsClick}
          value={
            financialValues.totalDepositAmount
              ? financialValues.totalDepositAmount
              : 0
          }
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.totalDepositAmount,
              value
            )
          }
          placeholderVal={"0"}
          readOnly={true}
          belowText={String.Dashboard.financialsnapshotFeilds.totalBalace}
          // asterrisk={true}
          // errorChecks={errorFields}
        />

        <StyledDivider />
        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.mutualfundTitle}
          Icon={MutualFund}
          editVisible={false}
          value={financialValues.totalMutualFundsAmount}
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.totalMutualFundsAmount,
              value
            )
          }
          // errorChecks={errorFields}
          belowText={String.Dashboard.financialsnapshotFeilds.availableBalance}
        />
        <StyledDivider />

        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.stocksTitile}
          Icon={Stocks}
          editVisible={false}
          value={financialValues.totalStocksAmount}
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.totalStocksAmount,
              value
            )
          }
          // errorChecks={errorFields}
          belowText={String.Dashboard.financialsnapshotFeilds.availableBalance}
        />
        <StyledDivider />
        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.policyTitle}
          Icon={Policy}
          editVisible={true}
          onEditClick={HandleEdit}
          setIsClick={setIsClick}
          value={
            financialValues.totalPolicyAmount
              ? financialValues.totalPolicyAmount
              : 0
          }
          placeholderVal={"0"}
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.totalPolicyAmount,
              value
            )
          }
          readOnly={true}
          belowText={String.Dashboard.financialsnapshotFeilds.totalCoverage}
          asterrisk={true}
          errorChecks={errorFields}
        />
        <StyledDivider />
        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.npsTitle}
          Icon={NPS}
          editVisible={true}
          onEditClick={HandleEdit}
          setIsClick={setIsClick}
          value={
            financialValues.totalNpsAmount ? financialValues.totalNpsAmount : 0
          }
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.totalNpsAmount,
              value
            )
          }
          readOnly={true}
          // errorChecks={errorFields}
          belowText={String.Dashboard.financialsnapshotFeilds.totalAmount}
        />
        <StyledDivider />
        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.AvgExpensesTitle}
          Icon={EVGExpense}
          editVisible={false}
          value={financialValues.avgExpenses}
          placeholderVal={"0"}
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.avgExpenses,
              value
            )
          }
          belowText={String.Dashboard.financialsnapshotFeilds.monthlyExpenses}
          asterrisk={true}
          errorChecks={errorFields}
        />
        <StyledDivider />
        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.loanTitle}
          Icon={Loan}
          editVisible={false}
          value={financialValues.loanAmount}
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.loanAmount,
              value
            )
          }
          toolTip={true}
          tooltipText={String.Dashboard.totolAMountCardTooltip.loanTooltip}
          // errorChecks={errorFields}
          belowText={String.Dashboard.financialsnapshotFeilds.totalLiabilities}
        />
        <StyledDivider />
        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.EMITitle}
          Icon={EMI}
          editVisible={false}
          value={financialValues.emiAmount}
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.emiAmount,
              value
            )
          }
          toolTip={true}
          tooltipText={String.Dashboard.totolAMountCardTooltip.emiTooltip}
          // errorChecks={errorFields}
          belowText={String.Dashboard.financialsnapshotFeilds.monthlyEMI}
        />
        <StyledDivider />
        <FinancialBox
          title={String.Dashboard.financialsnapshotFeilds.ProvidentFundTitle}
          Icon={PF}
          editVisible={true}
          onEditClick={HandleEdit}
          setIsClick={setIsClick}
          value={
            financialValues.providentFundAmount
              ? financialValues.providentFundAmount
              : 0
          }
          handleChange={(value) =>
            onHandleChange(
              String.Dashboard.financialsnapshotFeilds.totalPF,
              value
            )
          }
          readOnly={true}
          // errorChecks={errorFields}
          belowText={String.Dashboard.financialsnapshotFeilds.totalBalace}
        />
      </Box>
      <StyledACRButton>
        <ACRButton
          label={String.Dashboard.viewDashboard}
          style={{
            width: "100%",
            maxWidth: "350px",
            backgroundColor: getColor.ColorButtonPrimarysurface,
            color: getColor.PrimaryWhite,
            borderRadius: "40px",
            p: "10px",
            mb: "20px",
            height: "60px",
            lineHeight: "22.2px",
            fontWeight: 700,
            fontSize: "16px",
            textAlign: "center",
            textTransform: "initial",
          }}
          onClickButton={handleViewDashbord}
        />
      </StyledACRButton>
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage.message || errors}
        handleClose={() => {
          setSnackbarOpen(false);
        }}
        severity={snackbarMessage.severity}
      />
      {selectedBox === String.Dashboard.financialsnapshotFeilds.depositTitle &&
        isClick && (
          <DepositModel
            Title={String.Dashboard.financialsnapshotFeilds.depositTitle}
            feildsLabel1={"Name"}
            open={isClick}
            values={financialValues.deposits || {}}
            handlClose={handleClose}
            onSubmit={handleDepositSubmit}
          />
        )}
      {selectedBox === String.Dashboard.financialsnapshotFeilds.policyTitle &&
        isClick && (
          <PolicyModel
            Title={String.Dashboard.financialsnapshotFeilds.policyTitle}
            feildsLabel1={"Name"}
            open={Boolean(selectedBox)}
            handlClose={handleClose}
            onSubmit={handlePolicySubmit}
            values={financialValues.policies || {}}
          />
        )}
      {selectedBox === String.Dashboard.financialsnapshotFeilds.npsTitle &&
        isClick && (
          <NPSModel
            Title={String.Dashboard.financialsnapshotFeilds.npsTitle}
            feildsLabel1={"Name"}
            open={Boolean(selectedBox)}
            handlClose={handleClose}
            onSubmit={handleNPSSubmit}
            values={financialValues.npsList || {}}
          />
        )}
      {selectedBox ===
        String.Dashboard.financialsnapshotFeilds.providentFundtitile &&
        isClick && (
          <ProfiduntFundModel
            Title={String.Dashboard.financialsnapshotFeilds.providentFundtitile}
            feildsLabel1={"Name"}
            open={Boolean(selectedBox)}
            handlClose={handleClose}
            onSubmit={handlePFSubmit}
            values={financialValues.providentFundAmount || {}}
          />
        )}
    </StyledContainer>
  );
};

export default FinancialSnapshot;
